export default __webpack_public_path__ + "static/media/case-interface-new.7a6642cd.jpg";